import axios from 'axios';
import Vue from 'vue';



const state = { status: '', topActivity: {}, activities: [], activity: {}, error: {} };

const getters = {
  getActivity: state => state.activity,
  getActivities: state => state.activities,
  getError: state => state.error,
  getActivityById: state => id => state.activities.find(activity => activity.id === id),
  getTopActivity: state => state.topActivity,
};

const actions = {
  activitiesRequest({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
    axios({ url: `${process.env.VUE_APP_ROOT_API}/activities/` })
      .then(resp => {
        const activities = resp.data.activities;
        const top_activity = resp.data.top_activity;
        commit('setTopActivity', top_activity);
        commit('setActivities', activities);
        resolve(resp);
      })
      .catch(error => {
        reject(error);
       })
      })
  },
  updateActivity({commit, dispatch}, activity) {
    return new Promise((resolve, reject) => {
      axios({url: `${process.env.VUE_APP_ROOT_API}/activities/${activity.activity_id}/track/`, data: activity, method: 'POST'})
      .then(resp => {

        commit('setActivity', resp);
        resolve(resp);
      })
      .catch(error => {
        const err = error.response.data;
        commit('setError', err);
        reject(error)
      })
    })
  },
  activityRequest({ commit, dispatch }, activity_id) {
    return new Promise((resolve, reject) => {
    axios({ url: `${process.env.VUE_APP_ROOT_API}/activities/${activity_id.act_id}/` })
      .then(resp => {
        commit('setActivity', resp.data);
        resolve(resp);
      })
      .catch(error => {
        reject(error);
       })
      })
  },
};

const mutations = {
  setActivity(state, activity) {
    state.status = 'success';
    state.error = {};
    state.activity = activity;
  },
  setTopActivity(state, top_activity){
    state.status = 'success';
    state.topActivity = top_activity;
  },
  setActivities (state, activities) {
    state.status = 'success';
    state.error = {};
    state.activities = activities;
  },
  setError(state, error) {
    state.status = 'error';
    state.error = error;
  },
};

const namespaced = true;
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
